enum ModalType {
  DEFAULT = 'default',
  FULLSCREEN = 'fullscreen',
}

export default ModalType;
